export enum DataInterval {
  Daily = '1d',
  Weekly = '1w',
  Monthly = '1m',
  Annually = '1y',
}

export enum S3Command {
  deleteObject = 'deleteObject',
  listObjects = 'listObjects',
  getObject = 'getObject',
  putObject = 'putObject',
}
